import { FC, useCallback, useEffect } from "react";
import { notification } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { useCreateRecordV2 } from "@lhd/hooks";
import Button from "@lhd/components/Button";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { AppTypes, IPermissionItem } from "@lhd/types";
import { handleDataSubmitFinish } from "../../../untils";
import { useParams } from "react-router-dom";
import { getCompanyId } from "@lhd/utility";

export interface ButtonSaveAsNewProps {
  appType: AppTypes;
  appId: string;
  form: FormInstance<any>;
  appParts?: AppPartType[];
  isEditing: boolean;
  isUpdating?: boolean;
  onLoadingChange?: (loading: boolean) => void;
  permission?: IPermissionItem;
}

const ButtonSaveAsNew: FC<ButtonSaveAsNewProps> = ({
  appType,
  appId,
  form,
  appParts,
  isEditing,
  isUpdating = false,
  onLoadingChange,
  permission,
}) => {
  const { companyId: companyIdParam } = useParams();
  const companyId = Number(companyIdParam || getCompanyId());
  const { mutateAsync: createRecordAsync, isLoading: isCreating } =
    useCreateRecordV2({ appType, appId, companyId });

  useEffect(() => {
    onLoadingChange?.(isCreating);
  }, [isCreating, onLoadingChange]);

  const handleSaveAsNewRecord = useCallback(async () => {
    if (!appParts?.length) return;
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const dataSubmit = handleDataSubmitFinish(values, appParts, appType);
      await createRecordAsync({ payload: dataSubmit });
    } catch (e: any) {
      if (e?.errorFields) return;
      notification["error"]({
        message:
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          "保存に失敗しました",
      });
    }
  }, [appParts, createRecordAsync, form, appType]);

  return (
    <Button
      disabled={!isEditing || isUpdating || isCreating || !permission?.create}
      loading={isCreating}
      label={"別レコード保存"}
      onClick={handleSaveAsNewRecord}
    />
  );
};

export default ButtonSaveAsNew;
